import CkeditorRenderer from '../ckeditor-renderer/ckeditor-renderer';
import styles from './investment-form.module.scss';
import moment from 'moment';
import { useEffect, useState } from 'react';

export default function InvestmentForm({ investment, isDesktop, onSubmit = null, startDate, isRetreat = false }) {
  // const [isPassDuedate, setIsPassDuedate] = useState(false);
  const [isPassEarlyBird, setPassEarlyBird] = useState(false);
  const [investmentSpot, setInvestmentSpot] = useState([]);
  const [earlyBird, setEarlyBird] = useState(0);
  useEffect(() => {
    const compare = moment() > moment(startDate).subtract(2, 'months');
    const passEarly = moment() > moment(startDate).subtract(6, 'months');
    if (compare && !isRetreat) {
      setInvestmentSpot(
        investment?.spots?.map((element) => {
          return {
            ...element,
            full_price: element.full_price,
          };
        }),
      );
    } else {
      setInvestmentSpot(investment?.spots);
    }
    setEarlyBird(investment?.past_early_bird);
    setPassEarlyBird(passEarly);
    // setIsPassDuedate(compare);
  }, []);
  const renderSubmitButton = () => {
    return (
      <div className={styles.book}>
        <>
          <button className={styles.submit} onClick={onSubmit}>
            Book now
          </button>
          {investment?.past_early_bird > 0 && !isPassEarlyBird && <p style={{ marginTop: 10 }}>{investment.comment}</p>}
        </>
        {/* {isDesktop ? (
          <>
            <button className={styles.submit} onClick={onSubmit}>
              Book now
            </button>
            <p style={{ marginTop: 10 }}>{investment?.comment}</p>
          </>
        ) : (
          <>
            <p style={{ marginBottom: 30 }}>{investment?.comment}</p>
            <button className={styles.submit} onClick={onSubmit}>
              Shared Tripple – Book now
            </button>
          </>
        )} */}
      </div>
    );
  };

  return (
    <div id="booknow" className={styles.investment}>
      <p className={styles.title}>Investment</p>
      <div className={styles.content}>
        <div className={styles.features}>
          {investment?.what_you_get?.map((element) => (
            <div style={{ marginTop: 50 }} key={element.title}>
              <p className={styles.category}> {element.title}</p>
              <div className={styles.description}>
                <CkeditorRenderer html={element.description}></CkeditorRenderer>
              </div>
            </div>
          ))}
        </div>

        <div className={styles.purchase}>
          {investmentSpot.map((element) => (
            <div style={{ marginTop: isDesktop ? 50 : 100 }} key={element.title}>
              <p className={styles.category}>
                <div>
                  {element.title}
                  <div className={styles.description_small}>{element.description}</div>
                </div>
                <span>
                  {element.meta} ${isPassEarlyBird ? element.full_price + earlyBird : element.full_price}
                </span>
              </p>
            </div>
          ))}

          {renderSubmitButton()}
        </div>
      </div>
    </div>
  );
}
